import { creating, exist, Id } from '@campaign-portal/namespace/common/id';
import { ConnectionType, VendorType } from '@campaign-portal/namespace/common/enums';
import {
	Endpoint,
	HttpSettings,
	SmppSettings,
	WhatsappConnectionSettings,
} from '@campaign-portal/namespace/entities/endpoints/specs';

export interface EndpointEntityConfig<ID = exist | creating> extends Partial<Endpoint<ID>> {
	id: ID;
}

export class EndpointEntity<ID = exist | creating> implements Endpoint<ID> {
	[key: string]: unknown;

	id: ID;
	name: string;
	endpointProtocol: ConnectionType;
	isActive: boolean;
	isOnline: boolean;
	url: string | null;
	port: number | null;
	login: string;
	password: string;
	priority: number;
	availableCountryNetList: Id<exist>[] | null;
	vendorSubscription: Id<exist>;
	vendorType?: VendorType;
	groups?: Id<exist>[];
	numberOfMessages?: number;
	smppSettings?: SmppSettings;
	httpSettings?: HttpSettings;
	whatsappSettings?: WhatsappConnectionSettings;

	readonly creationDate?: string | null;
	readonly createdBy?: string | null;
	readonly lastUpdated?: string | null;
	readonly modifiedBy?: string | null;

	constructor(config: EndpointEntityConfig<ID>) {
		this.id = config.id;
		this.name = config.name ?? '';
		this.endpointProtocol = config.endpointProtocol ?? ConnectionType.SMPP;
		this.isActive = config.isActive ?? true;
		this.isOnline = config.isOnline ?? false;
		this.url = config.url ?? null;
		this.port = config.port ?? null;
		this.login = config.login ?? '';
		this.password = config.password ?? ''; // NOSONAR not a hardcoded credential
		this.priority = config.priority ?? 100;
		this.availableCountryNetList = config.availableCountryNetList ?? [];
		this.vendorSubscription = config.vendorSubscription ?? 0;
		this.vendorType = config.vendorType;
		this.groups = config.groups;
		this.numberOfMessages = config.numberOfMessages;
		this.smppSettings = config.smppSettings;
		this.httpSettings = config.httpSettings;
		this.whatsappSettings = config.whatsappSettings;
		this.creationDate = config.creationDate;
		this.createdBy = config.createdBy;
		this.lastUpdated = config.lastUpdated;
		this.modifiedBy = config.modifiedBy;
	}

	isSmpp(): boolean {
		return this.endpointProtocol === ConnectionType.SMPP;
	}

	isHttp(): boolean {
		return this.endpointProtocol === ConnectionType.HTTP;
	}
}
